// submenus
import role from './role'
import person from './person'
import mainPerson from './main-person'
import mainProperty from './main-property'
import mainVehicle from './main-vehicle'
import appraisal from './appraisal'
import headers from '../share/task-headers'
import groupUser from './group-user'

export default [
  ...role,
  ...person,
  ...headers('intgen', 'generali-CRLS'),
  ...mainPerson,
  ...mainProperty,
  ...mainVehicle,
  ...appraisal,
  ...groupUser
]
